import React, {useRef, useEffect, useState} from 'react';
import { Stack, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import PatientCard from '../display/PatientCard';
import { useHistoryEntryTypes } from '../../../hooks/history/useHistoryEntryTypes';
import DefaultHistoryEntryTypesSeederDialog from './DefaultHistoryEntryTypesSeederDialog';
import PatientHistoryList from '../lists/PatientHistoryList';
import ProceduresList from '../lists/ProceduresList';
import UpcomingAppointmentsList from '../lists/UpcomingAppointmentsList';
import VitalsList from '../lists/VitalsList';
import AttachmentsList from '../lists/AttachmentsList';
import { getFilesByPetId } from '../../../api/uploadService';

export default function PatientSummary({ open, onClose, pet = null }) {

    const childRef = useRef();

    const handleClose = () => onClose();

    const [seederDialogOpen, setSeederDialogOpen] =  React.useState(false);

    const [oldRecords, setOldRecords] = useState(null);

    const fetchOldRecords = async () => {
      const res = await getFilesByPetId(pet.id, 1, 100, "oldRecords");
      setOldRecords(res);
    };

    const onEmptyData = () => {
        setSeederDialogOpen(true);
    };
    
    const { historyEntryTypes, loading, setHistoryEntryTypes } = useHistoryEntryTypes(null, onEmptyData);

    React.useEffect(() => {
      if (open && pet)
      {
        fetchOldRecords();
      }
    }, [open, pet]);

    if (!pet) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
              <>
              <Typography variant="h6" component="span" sx={{ mb: 0 }}>Patient Medical History</Typography>
              <br />
              <Typography variant="h6" component="span" sx={{ mb: 0 }}>{`${pet.name} (${pet.owner.last_name}, ${pet.owner.first_name})`}</Typography>
              </>
            </DialogTitle>
            <DialogContent dividers>
              <Stack spacing={2}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <PatientCard pet={pet}/>
                </Box>
                <PatientHistoryList 
                    ref={childRef}
                    pet={pet}
                />
                {/* <ProceduresList 
                  label='Latest Procedures'
                  pet={pet}
                  showAddButton={false}
                  mode='petId'
                /> */}
                <UpcomingAppointmentsList 
                  pet={pet}
                  mode='pet'
                />
                <VitalsList 
                  pet={pet}
                />
                <AttachmentsList 
                  title='Old Records'
                  tags={["oldRecords"]}
                  fetchData={fetchOldRecords}
                  pet={pet}
                  attachments={oldRecords?.data || []}
                />
              </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => childRef.current?.handleCreateHistory()}>New Med. Hist.</Button>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        <DefaultHistoryEntryTypesSeederDialog
            open={seederDialogOpen}
            setOpen={setSeederDialogOpen} 
        />
        </React.Fragment>
    );
}